import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import { OFFRE_ETE_FIN } from "@/data/tarifs";

/**
 * Bandeau saisonnier temporaire (offre été). Se désactive tout seul après
 * OFFRE_ETE_FIN — pour changer/retirer l'offre, éditer ce fichier (et/ou
 * OFFRE_ETE_FIN dans data/tarifs.js) sans toucher à Home.jsx.
 */
export default function SeasonalBanner() {
  const finOffre = new Date(`${OFFRE_ETE_FIN}T23:59:59`);
  if (Date.now() > finOffre.getTime()) return null;

  return (
    <section className="py-8 bg-cream border-b" style={{ borderColor: "var(--border-light)" }} data-testid="seasonal-banner">
      <div className="container-x">
        <div
          className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 p-6 md:p-8 rounded-lg border-l-4"
          style={{ background: "var(--bg-light)", borderColor: "var(--orange)" }}
        >
          <div>
            <div className="font-mono text-xs uppercase tracking-widest mb-2" style={{ color: "var(--orange)" }}>
              OFFRE ÉTÉ · JUSQU'AU 31 JUILLET
            </div>
            <h2 className="text-xl md:text-2xl mb-2" data-testid="seasonal-banner-title">
              Avant de partir en vacances, sécurisez votre domicile.
            </h2>
            <p className="text-base" style={{ color: "var(--ink-muted)" }}>
              Installation de serrure carénée blindée certifiée A2P — <strong style={{ color: "var(--ink)" }}>990€ TTC fournie posée</strong>, poignée blindée dès <strong style={{ color: "var(--ink)" }}>249€</strong>. Devis gratuit.
            </p>
          </div>
          <div className="flex gap-3 flex-wrap flex-shrink-0">
            <Link to="/tarifs" className="btn btn-ghost-navy" data-testid="seasonal-banner-tarifs">
              Voir tous les tarifs <ArrowRight size={18} />
            </Link>
            <Link to="/contact" className="btn btn-urgence" data-testid="seasonal-banner-devis">
              <FileText size={18} /> Demander un devis
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
